import { createRouter, createWebHistory } from 'vue-router'
import {getWithExpiry} from '../utils/local'



const routes = [
  {
    path: '/',
    name: 'home',
    component: ()=>import("../views/HomeView.vue")
  },
  {
    path:'/videoTalk',
    name:'videoTalkPage',
    component:()=>import("../views/videoTalkPage.vue"),
    meta: {
      title: "视频通话",
    }
  },
  {
    path: '/login',
    name: 'login',
    component: ()=>import("../views/Login.vue")
  },
  {
    path: '/ani',
    name: 'ani',
    component: ()=>import("../views/ani.vue")
  },
  {
    path: '/works',
    name: 'works',
    component: ()=>import("../views/works.vue")
  }
]

const router = createRouter({
  // 修改路由模式为history
  // history: createWebHistory(process.env.BASE_URL),
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes
})

// 前置路由守卫
router.beforeEach((to, from, next) => {
  // 获取token
  // const user = localStorage.getItem('SC_USER')
  const user = getWithExpiry('NH_USER');
  // 判断token是否存在
  if (to.path == '/videoTalk' || to.path.indexOf('/works') != -1) {
    next()
  }else if (to.path != '/login' && !user) {// 判断token是否存在
    next('/login')
  } else {
    next()
  }
})

export default router
